// 技术栈标签分类
export interface TechStack {
  id: string;
  name: string;
  category: 'frontend' | 'backend' | 'mobile' | 'ai' | 'data' | 'devops' | 'design' | 'other';
}

// 前端技术
const frontendTechs: TechStack[] = [
  { id: 'react', name: 'React', category: 'frontend' },
  { id: 'vue', name: 'Vue', category: 'frontend' },
  { id: 'angular', name: 'Angular', category: 'frontend' },
  { id: 'typescript', name: 'TypeScript', category: 'frontend' },
  { id: 'nextjs', name: 'Next.js', category: 'frontend' },
  { id: 'webpack', name: 'Webpack', category: 'frontend' },
  { id: 'vite', name: 'Vite', category: 'frontend' },
  { id: 'tailwind', name: 'Tailwind CSS', category: 'frontend' },
  { id: 'flutter-web', name: 'Flutter Web', category: 'frontend' },
];

// 后端技术
const backendTechs: TechStack[] = [
  { id: 'nodejs', name: 'Node.js', category: 'backend' },
  { id: 'python', name: 'Python', category: 'backend' },
  { id: 'java', name: 'Java', category: 'backend' },
  { id: 'go', name: 'Go', category: 'backend' },
  { id: 'rust', name: 'Rust', category: 'backend' },
  { id: 'spring', name: 'Spring Boot', category: 'backend' },
  { id: 'django', name: 'Django', category: 'backend' },
  { id: 'fastapi', name: 'FastAPI', category: 'backend' },
  { id: 'nestjs', name: 'NestJS', category: 'backend' },
];

// 移动端技术
const mobileTechs: TechStack[] = [
  { id: 'ios', name: 'iOS', category: 'mobile' },
  { id: 'android', name: 'Android', category: 'mobile' },
  { id: 'flutter', name: 'Flutter', category: 'mobile' },
  { id: 'react-native', name: 'React Native', category: 'mobile' },
  { id: 'swift', name: 'Swift', category: 'mobile' },
  { id: 'kotlin', name: 'Kotlin', category: 'mobile' },
];

// AI/算法技术
const aiTechs: TechStack[] = [
  { id: 'machine-learning', name: '机器学习', category: 'ai' },
  { id: 'deep-learning', name: '深度学习', category: 'ai' },
  { id: 'nlp', name: '自然语言处理', category: 'ai' },
  { id: 'computer-vision', name: '计算机视觉', category: 'ai' },
  { id: 'tensorflow', name: 'TensorFlow', category: 'ai' },
  { id: 'pytorch', name: 'PyTorch', category: 'ai' },
  { id: 'opencv', name: 'OpenCV', category: 'ai' },
];

// 数据技术
const dataTechs: TechStack[] = [
  { id: 'mysql', name: 'MySQL', category: 'data' },
  { id: 'postgresql', name: 'PostgreSQL', category: 'data' },
  { id: 'mongodb', name: 'MongoDB', category: 'data' },
  { id: 'redis', name: 'Redis', category: 'data' },
  { id: 'elasticsearch', name: 'Elasticsearch', category: 'data' },
  { id: 'kafka', name: 'Kafka', category: 'data' },
  { id: 'spark', name: 'Spark', category: 'data' },
  { id: 'hadoop', name: 'Hadoop', category: 'data' },
];

// DevOps/运维技术
const devopsTechs: TechStack[] = [
  { id: 'docker', name: 'Docker', category: 'devops' },
  { id: 'kubernetes', name: 'Kubernetes', category: 'devops' },
  { id: 'jenkins', name: 'Jenkins', category: 'devops' },
  { id: 'git', name: 'Git', category: 'devops' },
  { id: 'aws', name: 'AWS', category: 'devops' },
  { id: 'azure', name: 'Azure', category: 'devops' },
  { id: 'gcp', name: 'GCP', category: 'devops' },
  { id: 'linux', name: 'Linux', category: 'devops' },
];

// 设计技术
const designTechs: TechStack[] = [
  { id: 'ui-design', name: 'UI设计', category: 'design' },
  { id: 'ux-design', name: 'UX设计', category: 'design' },
  { id: 'figma', name: 'Figma', category: 'design' },
  { id: 'sketch', name: 'Sketch', category: 'design' },
  { id: 'photoshop', name: 'Photoshop', category: 'design' },
];

// 其他技术
const otherTechs: TechStack[] = [
  { id: 'product-manager', name: '产品经理', category: 'other' },
  { id: 'project-manager', name: '项目管理', category: 'other' },
  { id: 'qa', name: '测试工程师', category: 'other' },
  { id: 'security', name: '安全工程师', category: 'other' },
  { id: 'blockchain', name: '区块链', category: 'other' },
  { id: 'game-dev', name: '游戏开发', category: 'other' },
];

// 所有技术栈
export const allTechStacks: TechStack[] = [
  ...frontendTechs,
  ...backendTechs,
  ...mobileTechs,
  ...aiTechs,
  ...dataTechs,
  ...devopsTechs,
  ...designTechs,
  ...otherTechs,
];

// 按分类获取技术栈
export const techStacksByCategory = {
  frontend: frontendTechs,
  backend: backendTechs,
  mobile: mobileTechs,
  ai: aiTechs,
  data: dataTechs,
  devops: devopsTechs,
  design: designTechs,
  other: otherTechs,
};

// 分类标签
export const categoryLabels: Record<string, string> = {
  frontend: '前端开发',
  backend: '后端开发',
  mobile: '移动端',
  ai: 'AI/算法',
  data: '数据技术',
  devops: 'DevOps',
  design: '设计',
  other: '其他',
};
